import { Box, SimpleGrid, VStack, useMediaQuery, Skeleton } from '@chakra-ui/react'

import Sort from 'components/Sort'
import { Maybe, Property } from 'generated/graphql'
import React from 'react'

import PropertyResultCard from '../PropertyResultCard'
import Pagination, { PaginationProps } from 'components/Pagination'
import { useAuthContext } from 'context/AuthProvider'

type PropertyListResultsProps = PaginationProps & {
  properties: Maybe<Property>[]
  propertyDataLoading: boolean
}
const PropertyListResults: React.FC<PropertyListResultsProps> = ({
  properties,
  propertyDataLoading,
  count,
  setLimit,
  start,
  setStart,
  limit
}) => {
  const { isAuthenticated } = useAuthContext()

  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')

  return (
    <Box display={isTabletOrMobile ? undefined : 'flex'} mt={6} alignItems="flex-start">
      <VStack spacing={8} flex={1}>
        <Sort totalResults={count} limit={limit} start={start} />
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3 }}
          w="100%"
          gap={6}
          alignItems="flex-start"
          justifyContent="center"
        >
          {propertyDataLoading
            ? Array.from(Array(limit).keys()).map((i) => (
                <Skeleton width="100%" key={i} rounded="md" height={390} />
              ))
            : properties?.map((res) => (
                <PropertyResultCard
                  key={res?.id}
                  onClick={() =>
                    window.open(
                      isAuthenticated ? `/auth/property/${res?.id}` : `/property/${res?.id}`,
                      '_blank'
                    )
                  }
                  property={res as Property}
                  isLoaded={!propertyDataLoading}
                />
              ))}
        </SimpleGrid>
        <Pagination
          setLimit={setLimit}
          py={16}
          start={start}
          setStart={setStart}
          count={count}
          limit={limit}
        />
      </VStack>
    </Box>
  )
}

export default PropertyListResults
